import { NgModule } from '@angular/core';
import { ApiCoreModule } from '@qtek/core/api-core';

@NgModule({
  imports: [ApiCoreModule],
})
export class MetaCoreModule {}
